import React from "react";

export const ImageHorizontalList = (props) => {
  const pstyle = {
    fontSize: props.data?.fontSize || "1em",
    lineHeight: "1.5em",
  };

  /* center alin the div for the images */
  const istyle = {
    width: "240px",
    height: "auto",
    display: "block",
    marginLeft: "auto",
  };

  const dstyle = {
    display: "flex",
    alignItems: "center",
  }


  return (
    <div id="team" className="text-left">
      <div className="container">
        <div className="col-md-12" >
          <p className="comexdealcolor" style={pstyle}>{props.data?.title}</p>
        </div>
        <div id="row" className="col-md-12" style={dstyle}>
          {props.data?.items
            ? props.data?.items.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 col-sm-2 team">
                  <div className="thumbnail">
                    {" "}
                    <a href={d.link} target="_blank" rel="noreferrer">
                    <img src={d.img} alt={d.name} style={istyle}/>
                    </a>
                    {/* <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div> */}
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
